import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';

class TransactionsFiltersView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    let {
      onFilterChange,
      filtersFormState,
    } = this.props;

    return null;
    return (
      <div className="filters-container admin-transactions-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onFilterChange}>
          <FormGroup>
            <label>Fake Filter:</label>
            <Select name="fakeFilter" options={['yes', 'no']} selectLabel="-" emptyOption/>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default TransactionsFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Transactions/TransactionFilters/TransactionFilters.view.js